export default {
    lineRegisterCode: 'รหัสการใช้งานไลน์',
    code: 'รหัส',
    create: 'สร้าง',
    cancel: 'ยกเลิก'
}
